module.exports = __webpack_public_path__ + "img/6_wgoods.48a6c2e3.jpg";